/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Type_Pick_ManualInputs */

const cs_ruian_type_pick_manual = /** @type {(inputs: Ruian_Type_Pick_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ nemovitosti (byt/dům) nelze určit z RÚIAN — vyberte prosím ručně, případně po načtení z katastru.`)
};

const en_ruian_type_pick_manual = /** @type {(inputs: Ruian_Type_Pick_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property type (apartment/house) cannot be determined from RÚIAN alone — select it manually or wait for cadastre lookup.`)
};

/**
* | output |
* | --- |
* | "Property type (apartment/house) cannot be determined from RÚIAN alone — select it manually or wait for cadastre lookup." |
*
* @param {Ruian_Type_Pick_ManualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_type_pick_manual = /** @type {((inputs?: Ruian_Type_Pick_ManualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Type_Pick_ManualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_type_pick_manual(inputs)
	return cs_ruian_type_pick_manual(inputs)
});